import { actions, actionTypes } from './modules';
import { takeLatest, select, call, put } from 'redux-saga/effects';
import { autoCompleteTermSelector } from './selectors';
import { commonApiServiceAsync } from '../../../services/commonApiService';

const { AUTOCOMPLETE_SEARCH } = actionTypes;

const { searchFailure, searchSuccess } = actions;

// this is hardcoded with realm, but should be abstracted so this can be used elsewhere
function* autoComplete(): any {
  const term = yield select(autoCompleteTermSelector);
  try {
    const { matches } = yield call(commonApiServiceAsync.search, { term, type: 'realm' });
    yield put(searchSuccess(matches));
  } catch (e) {
    yield put(searchFailure(e));
  }
}

function* watchAutocompleteSearch(): any {
  yield takeLatest(AUTOCOMPLETE_SEARCH, autoComplete);
}

export default [watchAutocompleteSearch()];
